export enum LocationType {
    FIELD = "FIELD",
    STACK = "STACK",
    CUSTOMER = "CUSTOMER"
}

export class Location {
    id: string;
    type: LocationType;
}